import React from 'react';
import { QStack } from '../../../QLayouts';

export const CustomFormContent: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <QStack spacing="16px">{children}</QStack>;
CustomFormContent.displayName = 'FilterCustomFormContent';
